// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + "2f41f71bc0c9ad2013f2" + "/js/" + chunkId + ".js";
};